import { debounce } from 'lodash';
import { useState, useEffect } from 'react';

const isBrowser = typeof window !== "undefined"

export const alternatePosition = (d, labelYPosition, offset) => 
  d.position === 'top' ? labelYPosition - offset : labelYPosition + offset

export const alternateYPosition = (position, defaultYPosition, offset) => 
  position === 'top' ? defaultYPosition - offset : defaultYPosition + offset

/* get window dimensions */
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}
/* end window dimensions */

/** alternate window */
export const useWindowSize = (initialState = "100%", { ttl = 100 } = {}) => {
  // initialState is used before the component mounts client-side
  const [width, setWidth] = useState(initialState)

  useEffect(() => {
    const calculateWidth = debounce(() => {
      setWidth(window.innerWidth)
    }, ttl)

    calculateWidth()
    window.addEventListener("resize", calculateWidth)

    return () => {
      // deregister event listener on component dismount
      window.removeEventListener("resize", calculateWidth)
    }
  }, [ttl])

  return width
}